module.exports = __webpack_public_path__ + "img/img-ffp-2.175eae54.jpg";